import { render, staticRenderFns } from "./AddCard.vue?vue&type=template&id=5b43b421&scoped=true"
import script from "./AddCard.vue?vue&type=script&lang=js"
export * from "./AddCard.vue?vue&type=script&lang=js"
import style0 from "./AddCard.vue?vue&type=style&index=0&id=5b43b421&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b43b421",
  null
  
)

export default component.exports